import React, { PureComponent } from 'react'

import { DateRange } from 'react-date-range-updated'

class Datepicker extends PureComponent {

  handleDateChange(dateObj) {
    this.props.onSelected()
    this.props.setFiltersData(dateObj.startDate, 'dateFilter')
    this.props.setFiltersData(dateObj.endDate, 'dateFilterUntil')
  }

  render() {

    const calTheme={
      DateRange      : {
        background   : '#ffffff'
      },
      Calendar       : {
        background   : 'transparent',
        color        : '#888',
      },
      // MonthAndYear   : {
      //   background   : '#e74c3c',
      //   color        : '#9e3024'
      // },
      // MonthButton    : {
      //   background   : '#c0392b'
      // },
      MonthArrowPrev : {
        borderRightColor : '#649ed6'
      },
      MonthArrowNext : {
        borderLeftColor : '#649ed6',
      },
      // Weekday        : {
      //   background   : '#e74c3c',
      //   color        : '#9e3024'
      // },
      Day            : {
        transition   : 'transform .1s ease, box-shadow .1s ease, background .1s ease'
      },
      DaySelected    : {
        background   : '#024781'
      },
      DayActive    : {
        background   : '#fed551',
        boxShadow    : 'none'
      },
      DayInRange     : {
        background   : '#649ed6',
        color        : '#fff'
      },
      DayHover       : {
        background   : '#fed551',
        color        : '#fff',
        transform    : 'scale(1.03) translateY(-2%)',
        boxShadow    : '0 1px 3px rgba(0, 0, 0, 0.3)'
      }
    }

    return (
      <div className="filter-datepicker">

        <DateRange
          calendars={1}
          startDate={this.props.d} 
          endDate={this.props.du}
          twoStepChange={true}
          onChange={this.handleDateChange.bind(this)}
          theme={calTheme}
          firstDayOfWeek={1}
          lang={'de'}
        />

      </div>
    )
  }
}

export default Datepicker


// WEBPACK FOOTER //
// ./src/components/parts/Datepicker.js